// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 774) return "static/chunks/framework-6f156d06676f80cd912a.js";
	if (chunkId === 678) return "static/chunks/678-4411748456b060607de5.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 806 ? "c0d53ec4" : chunkId) + "." + {"557":"04170fa62c3b06981d9d","806":"39ce1426080cd27ab2a3"}[chunkId] + ".js";
};